import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";

export const AuthWrapper = ({ children }) => {
    const hostParts = window.location.host.split('.');
    let subdomain = hostParts[0]; 
    const callbackUrl = (process.env.REACT_APP_ENVIRONMENT !== 'DR' && process.env.REACT_APP_ENVIRONMENT !== 'Stage' && process.env.REACT_APP_ENVIRONMENT !== 'Production' && process.env.REACT_APP_ENVIRONMENT !== 'Beta') ? process.env.REACT_APP_AUTH0_CALLBACK_URL : process.env.REACT_APP_AUTH0_CALLBACK_URL.replace(/^https:\/\/[^.]+/, `https://${subdomain}`);
    console.log('callbackUrl===', callbackUrl);

    const options = {
        domain: process.env.REACT_APP_AUTH0_DOMAIN,
        clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
        responseType: process.env.REACT_APP_AUTH0_RESPONSE_TYPE,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: process.env.REACT_APP_AUTH0_SCOPE,
        redirectUri: callbackUrl,
        cacheLocation: 'localstorage'
    };
    return <Auth0Provider {...options}>{children}</Auth0Provider>;
};
